<template>
    <div v-bind:style="style">
        <slot></slot>
    </div>
</template>

<script>
  export default {
    props: {
      enabled: {
        type: Boolean,
        default: true
      },
      margin: {
        type: Number,
        default: 0,
      },
    },

    data() {
      return {
        height: null,
        debounceAutoHeight: _.debounce(this.setAutoHeight, 100),
      };
    },

    computed: {
      /**
       * @return String
       */
      style() {
        return _.isNull(this.height) ? '' : `height: ${this.height}px;`;
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      setAutoHeight() {
        this.$nextTick(() => {
          const topOffset = this.$el.getBoundingClientRect().top;
          this.height = window.innerHeight - topOffset - this.margin;
        });
      },

      /**
       * @param {object|boolean} e
       * @return {undefined}
       */
      handleResize(e) {
        if (!this.enabled) {
          return;
        }

        if (e === true) {
          this.setAutoHeight();
        } else {
          this.debounceAutoHeight();
        }
      },
    },

    mounted() {
      this.handleResize(true);
      window.addEventListener('resize', this.handleResize)
    },

    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize)
    },
  }
</script>
